define(function(require, exports, module) {
    'use strict';
    const MenuView = require('modules/menu/menu.view.js');
    const _ = require('underscore');
    const core = require('core');
    const user = require('user');
    const getDynamicTagValue = require('../../../util/swiss-theme/dynamicTag.value.util');

    const { dispatcher } = require('bundle');
    require('widgets/accordion.widget');

    module.exports = MenuView.extend({

        subscribe: function() {
            MenuView.prototype.subscribe.apply(this, arguments);

            this.listenTo(core, {
                'sideMenu:close': this.handleCloseTap
            });
        },

        getStickySearch: function(isHidden) {
            const stickySearch = document.querySelector('#sticky_search');
            return stickySearch ? isHidden ? stickySearch.classList.add('hidden') : stickySearch.classList.remove('hidden') : null;
        },

        open: function() {
            MenuView.prototype.open.apply(this, arguments);
            const isApp = window.document.getElementById('application');
            if (isApp.classList.contains('quick')) {
                isApp.classList.remove('quick');
                dispatcher.dispatch('quickDeposit:hide');
            }

            this.getStickySearch(true);
        },

        close: function() {
            MenuView.prototype.close.apply(this, arguments);
            this.getStickySearch(false);
        },

        _renderSideMenu: function() {
            const userLang = user.get('lang') || Playtech.Variables.defaultLocale;
            const dynamicTagSocialIcons = getDynamicTagValue('SOCIAL');
            let socialIcons;

            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                return;
            }

            if (dynamicTagSocialIcons?.length) {
                const socialArray = dynamicTagSocialIcons.split(',');
                const social = ['instagram', 'youtube', 'linkedin', 'tiktok', 'facebook'];
                socialIcons = socialArray.reduce(function(target, key, index) {
                    const name = social.filter(el => key.includes(el)).length ? social.filter(el => key.includes(el))[0] : 'common';

                    target[index] = {
                        name,
                        path: key
                    };
                    return target;
                }, []);
            }

            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                lang: userLang.slice(0,2),
                isUserLogged: user.isLoggedIn(),
                socialIcons
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        }
    });
});
